// CardPage.jsx
import React, { useRef, useEffect } from "react";
import Form24 from "./Form24";
import FormPDFWrapper from "./FormPDFWrapper";

export default function Form24Wrapper({ rcData, apiTriggerDownload }) {
  const pdfRef = useRef();

  // Call this from API function when needed:
  useEffect(() => {
    // Register callback once after mount
    apiTriggerDownload(() => {
      pdfRef.current?.generatePDF();
    });
  }, []);

  return (
    <>
      <FormPDFWrapper ref={pdfRef} fileName={`${rcData?.rcNumber}.pdf`}>
        <Form24 rcData={rcData} />
      </FormPDFWrapper>
    </>
  );
}
